import { normalizeVoiceText, removeVoicePhrase } from './matchVoiceSearchCity';

/**
 * “הכי קרוב לרחוב…”, “closest to…” — sort the current results by distance to a place,
 * do not require the listing’s street field to match.
 */
const PROXIMITY_PHRASES = [
  // “לרחוב” is one spoken token (ל + רחוב), so keep glued forms before bare “ל”.
  'מה הכי קרוב לרחוב',
  'מי הכי קרוב לרחוב',
  'הכי קרוב לרחוב',
  'הכי קרובה לרחוב',
  'הכי קרובים לרחוב',
  'הכי קרובות לרחוב',
  'הקרוב ביותר לרחוב',
  'הקרובה ביותר לרחוב',
  'מה הכי קרוב ל',
  'מה הכי קרוב',
  'מי הכי קרוב ל',
  'מי הכי קרוב',
  'הכי קרוב ל',
  'הכי קרובה ל',
  'הכי קרובים ל',
  'הכי קרובות ל',
  'הקרוב ביותר ל',
  'הקרובה ביותר ל',
  'הקרובים ביותר ל',
  'closest to the street',
  'nearest to the street',
  'closest to street',
  'nearest to street',
  'closest to',
  'nearest to',
  'closest',
  'nearest',
  'which is closest to',
  'which is nearest to',
  'find the closest to',
  'show the closest to',
].sort((a, b) => b.length - a.length);

const PROXIMITY_FILLERS = [
  'מבין שניהם',
  'מבין שתיהן',
  'מבין התוצאות',
  'מתוך התוצאות',
  'מבין אלה',
  'מביניהם',
  'מביניהן',
  'מהתוצאות',
  'מאלה',
  'מהם',
  'המקום',
  'הנכס',
  'המשרד',
  'החלל',
  'among them',
  'among these',
  'of them',
  'of these',
  'from these',
  'the one',
  'one',
].sort((a, b) => b.length - a.length);

export function parseAssistantProximity(text: string): {
  proximity: boolean;
  remainder: string;
} {
  const hay = normalizeVoiceText(text);
  for (const phrase of PROXIMITY_PHRASES) {
    const next = removeVoicePhrase(hay, phrase);
    if (next === hay) {
      continue;
    }
    let remainder = next;
    for (const filler of PROXIMITY_FILLERS) {
      remainder = removeVoicePhrase(remainder, filler);
    }
    return { proximity: true, remainder: remainder.replace(/\s+/g, ' ').trim() };
  }
  return { proximity: false, remainder: hay };
}
